<template>
    <div id="Wrapper">
        <Alert
            ref="Alert"
            :message="alertMessage"
            :subMessage="alertSubMessage"
            :errorFlag="errorFlag"
            @confirmFinished="confirmFinished"
        />
    </div>
</template>
<script>

import Alert from '../../components/modal/Alert'
const apiUrl = process.env.VUE_APP_API_apiUrl;
const logoutUrl = process.env.VUE_APP_TOP_PAGE_URL;
const tenantId = process.env.VUE_APP_API_TENANT_ID;

export default {
    name: 'Flogin',
    data() {
        return {
            token: 'hoge',

            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false
        }
    },
    methods:{
        //**********************************************************/
        // APIの実施
        /**********************************************************/
        callApiForPostToken: async function(param, queries){
            // 関数return値を配置する変数
            var isApiData = "";
            await this.$store.dispatch('requestApi/postApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            .then(response => { // eslint-disable-line
                    this.infoCallingApi = this.$store.getters['requestApi/postApiInfo'];
                    isApiData = this.infoCallingApi;
            }, error => {// eslint-disable-line
                this.showResultMessage({
                    transitionLogoutPageFlg: true,
                    transitionTopPageFlg: false,
                    execFlg: false,
                    message:"認証エラー",
                    sub_message:"トップページに戻ります。",
                    errorFlag: true
                });
            })
            return isApiData
        },
        showResultMessage(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo();
            }
        },
    },
    created: async function(){
        //**********************************************************/
        // 認証APIの実施
        /***********************************************************/
        var queries = { 
            platform_request_token: this.$route.params.ticketToken,
            // tenant_id : 2,
            tenant_id : tenantId,
        };
        const getLiveAccessToken = await this.callApiForPostToken('auth', queries);
        // 認証成功時にLiveアクセストークンをブラウザで保持後、トップにリダイレクト
        if(getLiveAccessToken !== ""){
            sessionStorage.setItem('set_session', getLiveAccessToken["live_access_token"]);
            sessionStorage.setItem('set_session_exlire', getLiveAccessToken["expired_date"]);
            localStorage.setItem('set_local_exlire', getLiveAccessToken["expired_date"]);
            var site_no = -1;
            if(this.$route.query.site_no !== undefined){
                // this.$store.commit('auth/setSiteNo', this.$route.query.site_no); // PLATFORMアプリアイコンから遷移
                site_no = this.$route.query.site_no;
            }else if(this.$route.query.on_success_url !== undefined){
                // this.$store.commit('auth/setSiteNo', this.$route.query.on_success_url); // GRポータルorPLATFORM再ログインから遷移
                site_no = this.$route.query.on_success_url;
            }else{
                // TODO: PFから遷移時にgetパラメータ無しの場合エラー
            }
            location.href = "/Home?site_no=" + site_no;
        }else{
            // TODO: LIVEアクセストークン取得失敗の場合エラー
        }
    },
    components: {
        Alert,
    },
}
</script>
<style lang="scss">
</style>
